<template>
	<v-dialog v-model="dialog" persistent max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom color="primary">
					<template v-slot:activator="{ on }">
						<v-icon v-on="on">
							mdi-storefront-plus-outline
						</v-icon>
					</template>
					<span>{{'register in chain' | localize}}</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-show="!loading">
			<v-spacer></v-spacer>	
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{'Registration in the' | localize}} <span class="secondary--text">{{ channel.name }}</span> 
			</v-card-title>
			<v-divider />
			<v-card-text class="black--text">
				<v-container grid-list-md>

				<v-form v-model="valid" ref="form" lazy-validation>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-select dense
								v-model="trademark"
								:items="teamTrademarks"
								item-text="name"
								multiple
								color="secondary"
								item-color="secondary"
								:label="'Trademarks' | localize"
								:rules="[rules.not_empty]"
								@change="onceMore()">
							</v-select>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row v-if="error" class="text-center mx-2 error--text">{{'Error' | localize }} =>  {{ error }}</v-row>
				<v-row class="text-start text-pre-wrap mx-2">{{ message }}</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text class="text-capitalize"
					:disabled="!valid || Boolean(error) || changed"
					@click="calculate">
					{{'Calculate' | localize}}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="!changed || Boolean(error)"
					@click="addChannel">
					{{'Save' | localize}}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					@click="closeDialog">
					{{'Close' | localize}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import localizeFilter from '../../../filters/localize.filter.js';
import { localeNumber } from '../../../functions/common.js';
	export default {
		props: ['channel'],
		data () {
			return	{
				dialog: false,
				valid: false,
				changed: false,
				error: '',
				message: '',
				rules: {
					not_empty: v => v.length > 0 || localizeFilter('select min 1 item')
				},
				//props
				trademark: [],
				entry_fee: null,
				annual_fee: null,
				stores: this.channel.stores,
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			locale() {
				return this.$store.getters.locale;
			},
			game() {
				return this.$store.getters.game;
			},
			team() {
				return this.$store.getters.team;
			},
			trademarks () {
				return this.$store.getters.trademarks;
			},
			teamTrademarks() {
				let res = [];
				if (this.team) {
					const arr = [];
					this.team?.products.map(prod => {
						const inArr = arr.find(it => it === prod.trademarkId)
						if (!inArr) {
							arr.push(prod.trademarkId)
						}
					})
					res = this.trademarks.filter(it => arr.indexOf(it.id) !== -1)
				}
				return res
			},
		},
		methods: {
			onceMore() {
				this.error =''
				this.changed = false;
				this.message = '';
			},
			calculate() {
				if (this.$refs.form.validate()) {
					
					const num = this.trademark.length;
					this.entry_fee = this.channel.entry_fee * num;
					this.annual_fee  = this.channel.annual_fee * num;

					/* locale - massages*/
					if (this.locale == 'ro-RO') {
							
						this.message = `Vă rugăm să luați notă de sumele pe care va trebui să le achitați:

						taxă de intrare = $${localeNumber(this.entry_fee, this.locale)}
						taxă fixă anuală = $${localeNumber(this.annual_fee, this.locale)}
						--------------------------------------------------------------------------
					Dacă sunteți de acord, apăsați butonul "Salvare", altfel - apăsați "Închide"`
					} 
					else if (this.locale == 'ru-RU') {
							
						this.message = `Пожалуйста, обратите внимание на суммы, которые вам необходимо будет оплатить:

						вступительный взнос = $${localeNumber(this.entry_fee, this.locale)}
						ежегодная фиксированная плата = $${localeNumber(this.annual_fee, this.locale)}
						--------------------------------------------------------------------------
					Если Вы согласны, нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
					}
					else {
							
						this.message = `Please take note of the amounts you will need to pay:

            			entry fee = $${localeNumber(this.entry_fee, this.locale)}
						annual flat fee = $${localeNumber(this.annual_fee, this.locale)}
						--------------------------------------------------------------------------
					If you agree, press the button "Save", else - press "Close"`
					}

					this.changed = true;
				}
			},
			async addChannel () {
				if (this.trademark.length > 0) {
					let type = this.channel.type === 'brick&mortar' ? 8 : 7;
					const chan = {
						gameId: this.game.id,
						round: this.game.round,
						register_round: this.game.round,
						teamId: this.team.id,
						name: this.channel.name,
						stores: this.stores,
						type: type,
						entry_fee: this.entry_fee,
						annual_fee: this.annual_fee,
						trademarks: this.trademark,
						peak_market_coverage: this.channel.peak_market_coverage,
						num_trademarks: this.channel.num_trademarks,
						team: this.team
					}
					/*console.log(chan)*/
					try {
						//addChannel 
						await this.$store.dispatch('addChannel', chan)
						this.closeDialog ()					
					}
					catch (error) {
						this.error = error.message
					} 
				}
				else {
					this.error = 'Define trademarks you want to register in the chain'
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
				this.changed = false
				this.message = '';

			}
		},
	}
</script>
